// extracted by mini-css-extract-plugin
module.exports = {"w74y0rm":"w74y0rm"};